import { render } from "./HomeComponent.vue?vue&type=template&id=4c5192ac"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=4c5192ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__